import { Emc } from '../forms'

/** Common method to handle if EMC is considered online. */
export const getIsEmcOnline = (emc: Emc | null | undefined): boolean => {
  if (!emc) return false

  if (!emc.deviceStatus) return false

  return emc.deviceStatus !== 'unknown'
}
